import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Css/LoginPage.css';
import TopHeader from '../Header/TopHeader';
import Navbar from '../Header/Navbar';
import Swal from 'sweetalert2';

function Login() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://api.compliancekare.com/api/ApiAccount/Login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                const data = await response.json();

                const token = data.token;
                sessionStorage.setItem('token', token);
                Swal.fire({
                    title: "Success!",
                    text: "Login successful!",
                    icon: "success"
                }).then((result) => {
                    if (result.isConfirmed) {

                        navigate('/');
                    }
                });
            } else {
                Swal.fire({
                    title: "Error!",
                    text: "Invalid username or password. Please try again.",
                    icon: "error"
                });
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                title: "Error!",
                text: "Something went wrong. Please try again later.",
                icon: "error"
            });
        }
    };
    return (
        <>
            <TopHeader />
            <Navbar />
            <div className="wrapper">
                <div className="container1 p-4">
                    <div className="col-left">
                        <div className="login-text" style={{ marginLeft: "-2rem" }}>
                            <h2 >Compliancekare</h2>
                            <p>
                                File your ITR online in just 4 minutes
                            </p>
                            <div style={{ display: ' flex' }} >
                                <div >
                                    <a className="btn" href="">Google</a>
                                </div>
                                &nbsp; &nbsp;
                                <div >
                                    <a className="btn" href="">Facebook</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-right">
                        <div className="login-form">
                            <h2>Login</h2>
                            <form onSubmit={handleSubmit}>
                                <p>
                                    <input
                                        type="text"
                                        name="username"
                                        placeholder="Username"
                                        required
                                        onChange={handleInputChange}
                                    />
                                </p>
                                <p>
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="Password"
                                        required
                                        onChange={handleInputChange}
                                    />
                                </p>
                                <div>
                                    <p>
                                        <button className="btn btn-success" type="submit" >Login</button>
                                    </p>
                                </div>
                                <p>
                                    <a href="">Forget password?</a>
                                    <Link to="/Signup">Create an account.</Link>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;
